import { render, staticRenderFns } from "./WholesaleInquiresOther.vue?vue&type=template&id=20222e9b&scoped=true&"
import script from "./WholesaleInquiresOther.vue?vue&type=script&lang=js&"
export * from "./WholesaleInquiresOther.vue?vue&type=script&lang=js&"
import style0 from "./WholesaleInquiresOther.vue?vue&type=style&index=0&id=20222e9b&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20222e9b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VChipGroup,VCol,VRow,VTextField})
